import { Tab } from "@headlessui/react";
import StartRating from "components/StartRating/StartRating";
import React, { FC,useState,useEffect,Fragment  } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import visaPng from "images/vis.png";
import mastercardPng from "images/mastercard.svg";
import NcImage from "shared/NcImage/NcImage";
import { Route, Redirect,useHistory,Link,useParams} from 'react-router-dom';
import { Helmet } from "react-helmet";
import Input from "shared/Input/Input";
import Select from "shared/Select/Select";
import { Dialog, Transition } from "@headlessui/react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutFormAddon from "../CheckOutPage/CheckoutFormAddon";
import axios from 'axios'; 

export interface PayPageProps {
  className?: string;
  clientSecret?: string;
  DefaultUserID?: string;
}
const PayPage: FC<PayPageProps> = (
  {className = "",
  DefaultUserID = localStorage.getItem("user_id") ? localStorage.getItem("user_id") : ""
}) => {
    const params                                                  = useParams();
    const history                                                 = useHistory();
    const slug                                                    = Object.values(params);
    const [user_id,setUserId]                                     = useState(DefaultUserID);
    const [clientSecret, setClientSecret]                         = useState("");
    const [bookingDetails, setBookingDetails]                     = useState([]);
    const [isdataLoaded, setIsdataLoaded]                         = useState(false);
    const [totalNumTickets, setTotalNumTickets]                   = useState(0);
    const [totalNumMeals, setTotalNumMeals]                       = useState(0);
    const [totalNumPets, setTotalNumPets]                         = useState(0);
    const [sumTicketsMealsValue, setSumTicketsMealsValue]         = useState(0);
    const [sumFerryTicket, setSumFerryTicket]                     = useState(0);
    const [sumMeals, setSumMeals]                                 = useState(0);
    const [sumPets, setSumPets]                                   = useState(0);
    const [sumAddonValue, setSumAddonValue]                       = useState(0);
    const [details,setDetails]                                    = useState({ferry_meals_ticket:0,
                                                                              ferry_ticket:0,
                                                                              meals:0,
                                                                              pets:0});
    const queryParams                                             = new URLSearchParams(window.location.search);
    const step                                                    = queryParams.get("step");
    const [isclickStepfirst, setIsclickStepfirst]                 = useState(true);
    const [isclickStepSecond, setIsclickStepSecond]               = useState(false);
    const [isclickStepThird, setIsclickStepThird]                 = useState(false);
    const [isBookingHasPetsAllowed, setIsBookingHasPetsAllowed]   = useState(false);
    const [bookingResponse, setbookingResponse]                   = useState({totalBookings:0,
                                                                    is_booking_has_addintionals:false,
                                                                    is_booking_has_pets_allowed:false,
                                                                    checkin_date:"",checkout_date:"",
                                                                    totalNights:0,
                                                                    otherdates:[],
                                                                    html_addons:"",
                                                                    options:[{ label: '0', value: '' }],
                                                                    Petsoptions:[{ label: '0', value: '' }]});
    const [success, setSuccess]                                 = useState(false);
    const [errorMessage, setErrorMessage]                       = useState('');
    const [orderId, setOrderId]                                 = useState(false);
    const [paypalCurrency,setPaypalCurrency]                    = useState(""); 
    const [paypalClientid,setPaypalClientid]                    = useState(""); 
    const [stripeClientid,setStripeClientid]                    = useState(""); 
    const [isBookingFound,setIsBookingFound]                    = useState(false); 
    const [totalTicketDaysWise,setTotalTicketDaysWise]          = useState<Record<string, number>>({});
    const [mealWiseCount,setmealWiseCount]                      = useState<Record<string, number>>({});
    const [isstripeSingature, setIsstripeSingature]             = useState(false);
    const [isPaymetContrainer, setIsPaymetContrainer]           = useState(false);
    const [ispurchasedAddons, setIspurchasedAddons]             = useState(false);
    const [isBuyAddonButton,SetIsBuyAddonButton]                = useState(false);                
    
    


    useEffect(() => {
      setUserId(localStorage.getItem("user_id"));
      if(DefaultUserID==""){
        history.push("../login");
      }
    }, [DefaultUserID]);

    useEffect(() => {
        axios.get(process.env.REACT_APP_BASE_URL+'getBookings_v1?booking_code='+slug[0]+"&user_id="+user_id)
        .then(res => {
          setBookingDetails(res.data.bookings)
          if(res.data.bookings.length > 0){
            setIsBookingFound(true)
          }
          setIsdataLoaded(true);
          setbookingResponse(res.data);
          setIsBookingHasPetsAllowed(res.data.is_booking_has_pets_allowed);
          setStripeClientid(res.data.merchant_info.stripe_client_id);
          setPaypalClientid(res.data.merchant_info.paypal_client_id);
          setPaypalCurrency(res.data.merchant_info.default_currency);
          localStorage.removeItem('referralCandy');
          //setIspurchasedAddons(res.data.isAddonPurchased);
          if(res.data.isAddonPurchased==true){
            SetIsBuyAddonButton(false);
            //etIsPaymetContrainer(true);
            //SetIsBuyAddonButton(false);
          }
        })
    },[ispurchasedAddons]);

    
    function buyMoreaddons(){
      SetIsBuyAddonButton(true);
      setIsPaymetContrainer(false);
    }
    function closeFirstSteps() {
      if(details.ferry_meals_ticket==0 && details.ferry_ticket==0 && details.meals==0  && details.pets==0){
        console.log(details);
      }else{
        setTotalNumTickets(Number(details.ferry_meals_ticket)*2 + Number(details.ferry_ticket)*2);
        setTotalNumMeals(Number(details.ferry_meals_ticket) + Number(details.meals));
        setTotalNumPets(Number(details.pets));
        setIsclickStepfirst(false);
        setIsclickStepSecond(true);
        //setTotalTicketDaysWise({ ...totalTicketDaysWise, [`ferry_ticket_for_checkin[${bookingResponse?.checkin_date}]`]: (Number(details.ferry_meals_ticket)*2 + Number(details.ferry_ticket)*2)/2});
        //setTotalTicketDaysWise({ ...totalTicketDaysWise, [`ferry_ticket_for_checkout[${bookingResponse?.checkout_date}]`]: (Number(details.ferry_meals_ticket)*2 + Number(details.ferry_ticket)*2)/2});
      }
    }
    function backtoFirstSteps() {
        setIsclickStepfirst(true);
        setIsclickStepSecond(false);
        setSumTicketsMealsValue(0);
        setSumFerryTicket(0);
        setSumAddonValue(0);
        setSumMeals(0);
        setSumPets(0);
        setDetails({ferry_meals_ticket:0,
          ferry_ticket:0,
          meals:0,
          pets:0});
    }
    function closeFirstTwoSteps() {
      const totalTicketDayWiseObj = Object.values(totalTicketDaysWise);
      const totalTicketsChoosen = totalTicketDayWiseObj.reduce((accumulator, value) => {
        return Number(accumulator) + Number(value);
      }, 0);

      // FOR MEALS 
      const totalMealsQtyObj = Object.values(mealWiseCount);
      const  totalMealsQty = totalMealsQtyObj.reduce((accumulator1, value1) => {
        return Number(accumulator1) + Number(value1);
      }, 0);

      if(totalNumTickets > 0 && totalNumMeals > 0){
          if(totalTicketsChoosen==0){
            setIsstripeSingature(false);
            setErrorMessage('The number of tickets selected does not match with the tickets bought.');
          }else if(totalTicketsChoosen < totalNumTickets){
            setErrorMessage('The number of tickets selected does not match with the tickets bought.');
            setIsstripeSingature(false);
          }else if(totalTicketsChoosen > totalNumTickets){
            setErrorMessage('The number of tickets selected does not match with the tickets bought.');
            setIsstripeSingature(false);
          }else if(totalMealsQty==0){
            setErrorMessage('The number of meals selected does not match with the meals bought.');
          }else if(totalMealsQty < totalNumMeals){
            setErrorMessage('The number of meals selected does not match with the meals bought.');
          }else if(totalMealsQty > totalNumMeals){
            setErrorMessage('The number of meals selected does not match with the meals bought.');
          }else{
            setErrorMessage('');
            setIsclickStepfirst(false);
            setIsclickStepSecond(false);
            setIsclickStepThird(true);
            setIsstripeSingature(true);
            setIsPaymetContrainer(true);
          }
      }else if(totalNumTickets > 0 && totalNumMeals == 0){
          if(totalTicketsChoosen==0){
            setIsstripeSingature(false);
            setErrorMessage('The number of tickets selected does not match with the tickets bought.');
          }else if(totalTicketsChoosen < totalNumTickets){
            setErrorMessage('The number of tickets selected does not match with the tickets bought.');
            setIsstripeSingature(false);
          }else if(totalTicketsChoosen > totalNumTickets){
            setErrorMessage('The number of tickets selected does not match with the tickets bought.');
            setIsstripeSingature(false);
          }else{
            setErrorMessage('');
            setIsclickStepfirst(false);
            setIsclickStepSecond(false);
            setIsclickStepThird(true);
            setIsstripeSingature(true);
            setIsPaymetContrainer(true);
          }
      }else if(totalNumTickets == 0 && totalNumMeals > 0){
          if(totalMealsQty==0){
            setErrorMessage('The number of meals selected does not match with the meals bought.');
          }else if(totalMealsQty < totalNumMeals){
            setErrorMessage('The number of meals selected does not match with the meals bought.');
          }else if(totalMealsQty > totalNumMeals){
            setErrorMessage('The number of meals selected does not match with the meals bought.');
          }else{
            setErrorMessage('');
            setIsclickStepfirst(false);
            setIsclickStepSecond(false);
            setIsclickStepThird(true);
            setIsstripeSingature(true);
            setIsPaymetContrainer(true);
          }
      }else{
          setIsstripeSingature(true);
          setIsclickStepfirst(false);
          setIsclickStepSecond(false);
          setIsclickStepThird(true);
          setIsPaymetContrainer(true);
      }
    }
    function backtoSecondSteps() {
      setIsclickStepfirst(false);
      setIsclickStepSecond(true);
      setIsclickStepThird(false);
      setIsPaymetContrainer(false);
      setIsstripeSingature(false);
    }

  function handleChangeFerryTicketMeal(event:any) {
      setDetails({ ...details, [event.target.name]: event.target.value});
      setSumTicketsMealsValue(Number(20*event.target.value));
      setSumAddonValue(Number(20*event.target.value) + Number(sumFerryTicket) + Number(sumMeals) + Number(sumPets));
  }
  function handleChangeFerryTicket(event:any) {
      setDetails({ ...details, [event.target.name]: event.target.value});
      setSumFerryTicket(Number(12*event.target.value));
      setSumAddonValue(Number(sumTicketsMealsValue) + Number(12*event.target.value) + Number(sumMeals) + Number(sumPets));
  }
  function handleChangeMeals(event:any) {
      setDetails({ ...details, [event.target.name]: event.target.value});
      setSumMeals(Number(8*event.target.value));
      setSumAddonValue(Number(sumTicketsMealsValue) + Number(sumFerryTicket) + Number(8*event.target.value) + Number(sumPets));
  }
  function handleChangePets(event:any) {
      setDetails({ ...details, [event.target.name]: event.target.value});
      setSumPets(Number(30*event.target.value));
      setSumAddonValue(Number(sumTicketsMealsValue) + Number(sumFerryTicket) + Number(sumMeals) + Number(30*event.target.value));
  }
  function handleChangeDateWiseTicket(event:any){
    setTotalTicketDaysWise({ ...totalTicketDaysWise, [event.target.name]: event.target.value});
  }
  function handleChangeMealWiseCount(event:any){
    setmealWiseCount({ ...mealWiseCount, [event.target.name]: event.target.value});
  }
// STRIPR PAYMENT CODE START HERE 
  const options = {clientSecret};
  let stripePromise: any;
  if(stripeClientid!=''){
    stripePromise = loadStripe(stripeClientid);
  }
  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    if(sumAddonValue > 0 && isstripeSingature){
      axios.post(process.env.REACT_APP_BASE_URL+"stripe_signature_for_addon", {
        items: [{ amount: sumAddonValue,
                  choosedPackage : details,
                  TicketsBreakDown:totalTicketDaysWise,
                  MealsBreakDown:mealWiseCount,
                  BookingRerence_Number:slug[0],
                  user_id:DefaultUserID,
                  total_tickets:totalNumTickets,
                  total_meals:totalNumMeals,
                  total_pets:totalNumPets
              }]
      })
    .then(function (response) {
      setClientSecret(response.data.clientSecret);
      //setBookingRef(BookingRerence_Number)
    });
  }
  }, [sumAddonValue,isstripeSingature]);

 // STRIPE PAYMENT CODE END HERE 

 // PAYPAL PAYMENT CODE START HERE 
 const createOrder = (data:any, actions:any) => {
  return actions.order.create({
    purchase_units: [
      {
        reference_id: slug[0],
        /*custom_id:"adasd",*/
        description: 'Booking Payment For ',
        amount: {
          currency_code: 'SGD',
          value:sumAddonValue
        },
      },  
    ],
    application_context: {
      shipping_preference:'NO_SHIPPING'
    }
  })
    .then((orderID:any) => {
      setOrderId(orderID);
      console.log(orderID);
      return orderID
  })
}
const onApprove = (data:any,actions:any) => {
  return actions.order.capture().then(function (Paypaldetails:any) {
    const { payer } = Paypaldetails
    setSuccess(true);
    axios.post(process.env.REACT_APP_BASE_URL+"paypal_booking_addon", {
      items: [{ amount: sumAddonValue,
        choosedPackage : details,
        TicketsBreakDown:totalTicketDaysWise,
        MealsBreakDown:mealWiseCount,
        BookingRerence_Number:slug[0],
        user_id:DefaultUserID,
        total_tickets:totalNumTickets,
        total_meals:totalNumMeals,
        total_pets:totalNumPets,
        payment_details:Paypaldetails,
    }]
    })
  .then(function (response) {
    if(response.data.success){
      setIspurchasedAddons(true);
    }
  });
  })
}
const onError = (data?:any, actions?:any) => {
  setErrorMessage("An error occured with your payment")
};
  const renderBookingDetails = () => {
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-5 px-0 sm:p-6 xl:p-5">
        <h2 className="text-3xl lg:text-4xl font-semibold">
        Your booking is confirmed! 🎉
        </h2>

        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>

        {/* ------------------------ */}
        {bookingDetails && bookingDetails.length!=0 ? 
        <div>
      {bookingDetails.map((bookingItem:any) => (
        <div>
            <div className="flex justify-between space-y-6 br-sm-box">
          {/* <h3 className="text-2xl font-semibold">Booking detail's</h3> */}
          <div className="flex flex-col sm:flex-row flex-sm-div-col-none">
            <div className="flex-shrink-0 w-full sm:w-40">
              <div className=" aspect-w-4 aspect-h-3 sm:aspect-h-4 rounded-2xl overflow-hidden">
                <NcImage src={bookingItem.listing_image} />
              </div>
            </div>
            <div className="pt-0  sm:pb-0 sm:px-5 space-y-2">
              <div>
                <span className="text-sm text-neutral-500 dark:text-neutral-400 line-clamp-1 font-bold ">
                  {bookingItem.listing_name}
                </span>
                <span className="text-sm text-neutral-500 dark:text-neutral-400 line-clamp-1 mt-1">
                  {bookingItem.full_address}
                </span>
                
              </div>
              {/* <span className="block  text-sm text-neutral-500 dark:text-neutral-400">
                {bookingItem.beds} beds · {bookingItem.bathrooms} baths
              </span> */}
              <div className="mt-0 flex  date-time-sm">
            <div className="flex-1 p-0 flex space-x-0">
              <svg
                className="w-8 h-8 text-neutral-300 dark:text-neutral-6000"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.33333 8.16667V3.5M18.6667 8.16667V3.5M8.16667 12.8333H19.8333M5.83333 24.5H22.1667C23.4553 24.5 24.5 23.4553 24.5 22.1667V8.16667C24.5 6.878 23.4553 5.83333 22.1667 5.83333H5.83333C4.54467 5.83333 3.5 6.878 3.5 8.16667V22.1667C3.5 23.4553 4.54467 24.5 5.83333 24.5Z"
                  stroke="#D1D5DB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <div className="flex flex-col">
                 
                <span className="mt-1.5 text-lg font-semibold">
                  {bookingItem.booking_date}
                </span>
              </div>
            </div>
            <div className="flex-1 p-0 flex space-x-0">
              <svg
                className="w-8 h-8 text-neutral-300 dark:text-neutral-6000"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 5.07987C14.8551 4.11105 16.1062 3.5 17.5 3.5C20.0773 3.5 22.1667 5.58934 22.1667 8.16667C22.1667 10.744 20.0773 12.8333 17.5 12.8333C16.1062 12.8333 14.8551 12.2223 14 11.2535M17.5 24.5H3.5V23.3333C3.5 19.4673 6.63401 16.3333 10.5 16.3333C14.366 16.3333 17.5 19.4673 17.5 23.3333V24.5ZM17.5 24.5H24.5V23.3333C24.5 19.4673 21.366 16.3333 17.5 16.3333C16.225 16.3333 15.0296 16.6742 14 17.2698M15.1667 8.16667C15.1667 10.744 13.0773 12.8333 10.5 12.8333C7.92267 12.8333 5.83333 10.744 5.83333 8.16667C5.83333 5.58934 7.92267 3.5 10.5 3.5C13.0773 3.5 15.1667 5.58934 15.1667 8.16667Z"
                  stroke="#D1D5DB"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <div className="flex flex-col">
                 
                <span className="mt-1.5 text-lg font-semibold">{bookingItem.total_guests}</span>
              </div>
            </div>
          </div>
              
              {/* <StartRating reviewCount={bookingItem.reviewcount} point={bookingItem.reviewStar} isHost={false} /> */}
            </div>
          </div>
          <div className="space-y-0 sm-50-div">
        {/* <h2 className="text-3xl lg:text-4xl font-semibold">Booking detail's</h2> */}
          <div className="flex flex-col space-y-0 ">
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1 w-250-px">Booking code</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                #{bookingItem.confirmation_code}
              </span>
            </div>
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1 w-250-px">Date</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {bookingItem.booked_date}
              </span>
            </div>
            <div className="flex text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1 w-250-px">Total</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {bookingItem.total_payout}
              </span>
            </div>
            <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
              <span className="flex-1 w-250-px">Payment method</span>
              <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">
                {bookingItem.payment_method}
              </span>
            </div>
          </div>
        </div>
        </div>
        <div className="border-b border-neutral-200 dark:border-neutral-700 m-2"></div>
        </div>
        ))}
          {!isBuyAddonButton  && bookingResponse.is_booking_has_addintionals ?
          <div className="mt-6 text-center button-check-out-page">
            <ButtonPrimary onClick={buyMoreaddons}>
            <span id="button-text">Buy more add-ons</span>
            </ButtonPrimary>
          </div>
          :""
          }
        </div>
        :""}

        {/* ------------------------ */}
      
        {/* <div>
          <ButtonPrimary href="/">Explore more stays</ButtonPrimary>
        </div> */}
      </div>
    );
  };
  const renderContent = () => {
    return (
      
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-5 px-0 sm:p-6 xl:p-5">
        <Transition show={isclickStepfirst}>
        <h2 className="text-3xl lg:text-4xl font-semibold">
        Your Add-ons are here! 🎉
        </h2>
        <div className="border-b border-neutral-200 dark:border-neutral-700 mb-5 pb-6"></div>
        <div className="package-stap-1">
          <h2 className="text-3xl lg:text-2xl font-semibold mb-3 hidden">Choose your ferry & food package</h2>
          {/* <form className="grid grid-cols-1" method="POST" onSubmit={submitHandler}> */}
          <label className="rad-label ">
            <div className="w-100 mx-img-2">
                <img src="https://pictures.tinyaway.com/filters:format(webp)/500x500/lazarus/Two-way_Ferry_Meals.jpg"></img>
            </div>
            <div className="w-full-selecte">
              <h2 className="font-bold">Two-way Ferry + Pre-Order Meals</h2>
              <p>Operating  Ferry: Marina South Ferries via Marina South Pier</p>
            </div>
            <div className="rad-text">
              <div className="selected">
                <div className="rad-design">
                  <div>
                    <span>
                      <Select className="w-11 text-center"
                      name="ferry_meals_ticket"
                      id="ferry_meals_ticket"
                      autoComplete="off"
                      onChange={handleChangeFerryTicketMeal}
                      defaultValue={""}
                      >
                        {bookingResponse.options.map((option) => (
                        <option value={option.value}>{option.label}</option>
                        ))}
                    </Select>
                    </span>
                    <b>SGD20</b>
                    <span>Per unit</span>
                  </div>
                </div>
              </div>
            </div>
          </label>
          <label className="rad-label ">
            <div className="w-100">
              <img src="https://pictures.tinyaway.com/filters:format(webp)/500x500/lazarus/Two-way_Ferry.jpg"></img>
            </div>
            <div className="w-full-selecte">
              <h2 className="font-bold">Two-way Ferry</h2>
              <p>Operating  Ferry: Marina South Ferries via Marina South Pier</p>
            </div>
            <div className="rad-text">
              <div className="selected">
                <div className="rad-design">
                  <div>
                    <span>
                      <Select className="w-11 text-center" 
                      name="ferry_ticket"
                      id="ferry_ticket"
                      autoComplete="off"
                      onChange={handleChangeFerryTicket}
                      >
                       {bookingResponse.options.map((option) => (
                        <option value={option.value}>{option.label}</option>
                        ))}
                    </Select>
                    </span>
                    <b>SGD12</b>
                    <span>Per unit</span>
                  </div>
                </div>
              </div>
            </div>
          </label>
          <label className="rad-label ">
            <div className="w-100">
                <img src="https://pictures.tinyaway.com/filters:format(webp)/500x500/lazarus/Pre-Order_Meals.jpg"></img>
            </div>
            <div className="w-full-selecte">
            <h2 className="font-bold">Pre-Order Meals</h2>
            </div>
            <div className="rad-text">
              <div className="selected">
                <div className="rad-design">
                  <div>
                    <span>
                      <Select className="w-11 text-center"
                      name="meals"
                      id="meals"
                      autoComplete="off"
                      onChange={handleChangeMeals}
                      >
                      {bookingResponse.options.map((option) => (
                        <option value={option.value}>{option.label}</option>
                        ))}
                    </Select>
                    </span>
                    <b>SGD8</b>
                    <span>Per unit</span>
                  </div>
                </div>
              </div>
            </div>
          </label>
          {isBookingHasPetsAllowed ? 
            <label className="rad-label ">
             <div className="w-100">
                <img src="https://pictures.tinyaway.com/filters:format(webp)/500x500/lazarus/Pet_Fee.jpg"></img>
            </div>
              <div className="w-full-selecte">
              <h2 className="font-bold">Pet Fee</h2>
              </div>
              <div className="rad-text">
                <div className="selected">
                {/* <Input
                  fontClass=""
                  sizeClass="h-16 px-4 py-3"
                  rounded="rounded-3xl"
                  placeholder="Share your thoughts ..."
                  type="checkbox"
                  className="rad-input"
                  name="Pets"
                /> */}
                  <div className="rad-design">
                    <div>
                      <span>
                        <Select className="w-11 text-center"
                        name="pets"
                        id="pets"
                        autoComplete="off"
                        onChange={handleChangePets}
                        >
                       {bookingResponse.Petsoptions.map((option) => (
                        <option value={option.value}>{option.label}</option>
                        ))}
                      </Select>
                      </span>
                      <b>SGD30</b>
                      <span>Per Pet</span>
                    </div>
                  </div>
                </div>
              </div>
            </label>
            :""
          }
          <div className="flex flex-direction-column w-2/3">
            <div className="rad-label-note font-bold">
              Ferry From Sentosa Cove
            </div>
            <div className="rad-label-note">
            Option 1 : Yacht Cruise SG (speedboat) - Please purchase your tickets directly from this <a target="_blank" href="https://tickets.yachtcruisesg.com/attraction/exploring-lazarus-island-from-sentosa-cove-jetty">Link.</a> - Pets and luggages are not allowed on speedboat
            </div>
            <div className="rad-label-note">
            Option 2 : Marina South Ferries - Please contact MSF directly (<a href="emailto:msf@marinasouthferries.com">msf@marinasouthferries.com</a>) - Pets and luggages are allowed onboard.
            </div>
            </div>
          <div className="w-total-200">
          <div className="text-center mb-1"><b>Total: <span>SGD <span>{sumAddonValue}</span></span></b></div>
          <div className="text-center">
          <ButtonPrimary onClick={closeFirstSteps}>Continue </ButtonPrimary>
          </div>
          </div>
          {/* </form> */}
        </div> 
        </Transition>
         {/* ------------STEP 2 STARTED HERE------------ */}
        
        
        <Transition show={isclickStepSecond}>
          <div>
          {details.ferry_meals_ticket!=0 || details.ferry_ticket!=0 ?
          <div className="package-stap-2" >
            <h2 className="text-3xl lg:text-2xl font-semibold">Total number of ferry tickets: {totalNumTickets}</h2>
            <div className="border-b border-neutral-200 dark:border-neutral-700 mt-1"></div>
              <div className="flex gap-4 mt-3 date-time-row">
              <div>
                <p className="flex font-bold  date-pup items-center">
                    <span>Check in date:&nbsp;</span>
                    <span>{bookingResponse?.checkin_date}</span>
                </p>
                <p className="select-sm-box">
                  <span>2:30pm at Marina South Pier to Lazarus Island :</span>
                  <Select className="w-11 text-center"
                    name={`ferry_ticket_for_checkin[${bookingResponse?.checkin_date}]`}
                    id="ferry_ticket_for_checkin"
                    autoComplete="off"
                    // defaultValue={totalNumTickets/2}
                    onChange={handleChangeDateWiseTicket}
                    >
                    <option value={0}>0</option>
                    {(new Array(totalNumTickets)).fill(null).map((option, index) => (
                    <option value={index+1}>{index+1}</option>
                    ))}
                  </Select>
                </p>
              </div>
              <div className="pl-0">
                <p className="flex font-bold  date-pup items-center">
                  <span>Check out date:&nbsp;</span>
                  <span>{bookingResponse?.checkout_date}</span>
                </p>
                <p className="select-sm-box "> 
                  <span>11.30am at Lazarus Island to Marina South Pier :</span>
                  <Select className="w-11 text-center"
                    name={`ferry_ticket_for_checkout[${bookingResponse?.checkout_date}]`}
                    id="ferry_ticket_for_checkout"
                    autoComplete="off"
                    // defaultValue={totalNumTickets/2}
                    onChange={handleChangeDateWiseTicket}
                    >
                    <option value={0}>0</option>
                    {(new Array(totalNumTickets)).fill(null).map((option, index) => (
                    <option value={index+1}>{index+1}</option>
                    ))}
                    
                  </Select>
                </p>
              </div>
              {bookingResponse.totalNights > 1 ? 
                <div>
                  {bookingResponse.otherdates.map((otherdate:any) => (
                      <div>
                        <div className="pl-0">
                          <p className="flex font-bold  date-pup items-center">
                            <span>Other date:&nbsp;</span>
                            <span>{otherdate}</span>
                          </p>
                          <p className="select-sm-box mb-2">
                            <span>2:30pm at Marina South Pier to Lazarus Island :</span>
                            <Select className="w-11 text-center"
                              name={`ferry_ticket_for_other_dates_msp_to_li[${otherdate}]`}
                              id="ferry_ticket_for_other_dates"
                              autoComplete="off"
                              onChange={handleChangeDateWiseTicket}
                              >
                              <option value={0}>0</option>
                              {(new Array(totalNumTickets/2)).fill(null).map((option, index) => (
                              <option value={index+1}>{index+1}</option>
                              ))}
                            </Select>
                          </p>
                          <p className="select-sm-box ">
                            <span>11.30am at Lazarus Island to Marina South Pier :</span>
                            <Select className="w-11 text-center"
                              name={`ferry_ticket_for_other_dates_li_to_msp[${otherdate}]`}
                              id="ferry_ticket_for_other_dates"
                              autoComplete="off"
                              onChange={handleChangeDateWiseTicket}
                              >
                              <option value={0}>0</option>
                              {(new Array(totalNumTickets/2)).fill(null).map((option, index) => (
                              <option value={index+1}>{index+1}</option>
                              ))}
                            </Select>
                          </p>
                        </div>
                      </div>
                  ))}
                  
                </div>
              :""}
            </div>
          </div>
          :""}
          {totalNumMeals > 0 ?
            <div className="package-stap-3">
              <div>&nbsp;</div>
            <h2 className="text-2xl lg:text-2xl font-semibold mb-1">Total number of meals: {totalNumMeals}</h2>
            <div className="row-meal-page mb-2">
              <div className="img_meal">
                <img src="https://pictures.tinyaway.com/filters:format(webp)/500x500/lazarus/Mac_Cheese.jpg"></img></div>
                <div className="mane_meal"><p>Mac & Cheese</p></div>
                <div className="selec_meal">
                  <Select className="w-11"
                    name="meals_options[9]"
                    id="meals_options"
                    autoComplete="off"
                    onChange={handleChangeMealWiseCount}
                    >
                    <option value={0}>0</option>
                    {totalNumMeals!=undefined && (new Array(totalNumMeals)).fill(null).map((option, index) => (
                    <option value={index+1}>{index+1}</option>
                    ))}
                  </Select>
                </div> 
              </div>
              <div className="row-meal-page mb-2">
                <div className="img_meal">
                  <img src="https://pictures.tinyaway.com/filters:format(webp)/500x500/lazarus/Prawn_Chettinad_with_Lemon_Rice.jpg"></img></div>
                  <div className="mane_meal"><p>Prawn Chettinad with Lemon Rice</p></div>
                  <div className="selec_meal">
                  <Select className="w-11"
                      name="meals_options[8]"
                      id="meals_options"
                      autoComplete="off"
                      onChange={handleChangeMealWiseCount}
                      >
                     <option value={0}>0</option>
                     {totalNumMeals!=undefined && (new Array(totalNumMeals)).fill(null).map((option, index) => (
                    <option value={index+1}>{index+1}</option>
                    ))}
                    </Select>
                  </div> 
                </div>
       
                <div className="row-meal-page mb-2">
                  <div className="img_meal">
                    <img src="https://pictures.tinyaway.com/filters:format(webp)/500x500/lazarus/Chicken_Korma_with_Tomato_Rice.jpg"></img></div>
                    <div className="mane_meal"><p>Chicken Korma with Tomato Rice</p></div>
                    <div className="selec_meal">
                    <Select className="w-11"
                        name="meals_options[6]"
                        id="meals_options"
                        autoComplete="off"
                        onChange={handleChangeMealWiseCount}
                        >
                        <option value={0}>0</option>
                        {totalNumMeals!=undefined && (new Array(totalNumMeals)).fill(null).map((option, index) => (
                        <option value={index+1}>{index+1}</option>
                        ))}
                      </Select>
                    </div> 
                  </div>
       
                  <div className="row-meal-page mb-2">
                  <div className="img_meal">
                    <img src="https://pictures.tinyaway.com/filters:format(webp)/500x500/lazarus/Home_Style_Chicken_Curry_with_Pea_Pulao.jpg"></img></div>
                    <div className="mane_meal"><p>Home Style Chicken Curry with Pea Pulao</p></div>
                    <div className="selec_meal">
                    <Select className="w-11"
                        name="meals_options[7]"
                        id="meals_options"
                        autoComplete="off"
                        onChange={handleChangeMealWiseCount}
                        >
                        <option value={0}>0</option>
                        {totalNumMeals!=undefined && (new Array(totalNumMeals)).fill(null).map((option, index) => (
                        <option value={index+1}>{index+1}</option>
                        ))}
                      </Select>
                    </div> 
                  </div>
                  <div className="row-meal-page mb-2">
                    <div className="img_meal">
                      <img src="https://pictures.tinyaway.com/filters:format(webp)/500x500/lazarus/Stir-Fried_Basil_Chicken_with_Green_Curry_Fried_Rice.jpg"></img></div>
                    <div className="mane_meal"><p>Stir-Fried Basil Chicken with Green Curry Fried Rice.</p></div>
                    <div className="selec_meal">
                    <Select className="w-11"
                        name="meals_options[10]"
                        id="meals_options"
                        autoComplete="off"
                        onChange={handleChangeMealWiseCount}
                        >
                        <option value={0}>0</option>
                        {totalNumMeals!=undefined && (new Array(totalNumMeals)).fill(null).map((option, index) => (
                        <option value={index+1}>{index+1}</option>
                        ))}
                      </Select>
                    </div> 
                  </div>
                  
          </div>
          :""
          }
          {totalNumPets > 0 ?
          <div className="Pets-stap-3 ">
            <h2 className="text-2xl lg:text-2xl font-semibold mb-1">Total number of Pets: {totalNumPets}</h2>
          </div>
            :""
          }
           <div className="border-b border-neutral-200 dark:border-neutral-700 "></div>
          <div className="flex justify-between mt-3 text-right">
           <div className=""> <ButtonPrimary onClick={backtoFirstSteps}>Back </ButtonPrimary></div>
           {errorMessage && 
                    <div className="alert alert-warning h-1/2" role="warning alert"><span className="las la-exclamation-circle"></span>
                    {errorMessage}</div>}
            <div className="w-total-200">
              <div className="text-center mb-1"><b>Total: <span>SGD <span>{sumAddonValue}</span></span></b></div>
              <div className="text-center">
              <ButtonPrimary onClick={closeFirstTwoSteps}>Continue </ButtonPrimary>
              </div>
            </div>
         </div>
        </div>
        </Transition>
         {/* ------------STEP 2 MEALS STARTED HERE------------ */}

                       
         
        {/* ------------------------ */}
        

        {/* ------------------------ */}
        
        
      </div>
    
    );
  };
  const renderskeletonLoader = () => {
    return (
      <div className="custom-loader gap-3 justify-center lg:flex-row">
        <div className="border-neutral-200 sm:border sm:rounded-2xl w-70-1 w-70-loader">
          <div className="card m-2">
            <div className="card-body">
              <div className="row mb-5">
                <div className="col-12">
                  <div className="p-3 bg-grey skeleton"></div>
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-3">
                  <div className="p-5 bg-grey skeleton"></div>
                  <div className="p-2 bg-grey skeleton"></div>
                </div>
                <div className="col-8">
                  <div className="p-2 bg-grey mb-2 skeleton"></div>
                  <div className="p-2 bg-grey mb-2 skeleton"></div>
                  <div className="p-2 bg-grey mb-4 skeleton"></div>
                  <div className="p-2 bg-grey mb-2 skeleton"></div>
                </div>
              </div>
        <div className="row mb-3"></div>
        <div className="gap-3 mb-4 row">
          <div className="border-neutral-200 col-6 p-2.5 sm:border sm:rounded-2xl">
            <div className="p-2 bg-grey mb-2 skeleton"></div>
            <div className="p-2 bg-grey mb-0 skeleton"></div>
          </div>
          <div className="border-neutral-200 col-6 p-2.5 sm:border sm:rounded-2xl">
            <div className="p-2 bg-grey mb-2 skeleton"></div>
            <div className="p-2 bg-grey mb-0 skeleton"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <div className="bg-grey h-6 mb-3 p-2 skeleton"></div>
          </div>
        </div>
        <div className="row"><div className="col-3 mr-40">
          <div className="bg-grey mb-3 p-1 skeleton"></div>
        </div>
        <div className="col-3 p-1">
          <div className="bg-grey mb-3 p-1 skeleton"></div>
        </div>
        </div>
        <div className="row"><div className="col-3 mr-40">
          <div className="bg-grey mb-3 p-1 skeleton"></div>
        </div>
        <div className="col-3">
          <div className="bg-grey mb-3 p-1 skeleton"></div>
        </div>
        </div>
        <div className="row">
          <div className="col-3 mr-40">
            <div className="bg-grey mb-3 p-1 skeleton"></div>
          </div>
        <div className="col-3">
          <div className="bg-grey mb-3 p-1 skeleton"></div>
        </div>
        </div>
        <div className="row">
          <div className="col-3">
            <div className="bg-grey h-6 mb-3 p-2 skeleton"></div>
          </div>
        </div>
      </div>
      </div>
      </div>
    </div>
    );
  }
  const renderPatmentContainer = () =>{
      return(
          <>
          {/* ------------STEP Confirm and payment STARTED HERE------------ */}
          <Transition show={isclickStepThird}>
            <div className="w-full flex flex-col Confirm-and-payment mt-0 ">
              
              <div className="flex items-center justify-between pb-1">
                <h2 className="text-3xl lg:text-4xl font-semibold font-sm-mid-20">
                Confirm and payment
                </h2>
                <span><b>SGD${sumAddonValue}</b></span>
                </div>
              <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
              <div className="mt-4 button-check-out-page">
                <Tab.Group>
                  <Tab.List className="flex">
                  <Tab as={Fragment}>
                      {({ selected }) => (
                        <button
                          className={`px-4 py-1.5 sm:px-6 sm:py-2.5  rounded-full flex items-center justify-center focus:outline-none  ${
                            selected
                              ? "bg-neutral-800 text-white"
                              : " text-neutral-6000 dark:text-neutral-400"
                          }`}
                        >
                          <span className="mr-2.5">Credit card</span>
                          <img className="w-8" src={visaPng} alt="" />
                          <img className="w-8" src={mastercardPng} alt="" />
                        </button>
                      )}
                    </Tab>
                    <Tab as={Fragment}>
                      {({ selected }) => (
                        <button
                          className={`px-4 py-1.5 sm:px-6 sm:py-2.5 rounded-full focus:outline-none ${
                            selected
                              ? "bg-neutral-800 text-white"
                              : "text-neutral-6000 dark:text-neutral-400"
                          }`}
                        >
                          Paypal
                        </button>
                      )}
                    </Tab>
                  </Tab.List>
                  <div className="w-full border-b border-neutral-200 my-5 mb-3"></div>
                  <Tab.Panels>
                    <Tab.Panel className="space-y-5">
                    {clientSecret && stripePromise && (
                      <Elements options={options} stripe={stripePromise}>
                        <CheckoutFormAddon clientSecret={clientSecret} onChange={data => {setIspurchasedAddons(data ?? false)}}  />
                      </Elements>
                    )}
                    </Tab.Panel>
                    <Tab.Panel className="space-y-5">
                      <PayPalScriptProvider 
                          options={{
                            "client-id":paypalClientid,
                            currency: paypalCurrency,
                            intent: "capture",
                          }}
                      >
                      <div className="pt-4  w-1.5 ">
                        {/* <ButtonPrimary type="submit">Confirm and pay</ButtonPrimary>
                        */}
                        <PayPalButtons 
                          style={{color:"silver",
                                  layout:"horizontal",
                                  height:48,
                                tagline:false,
                              shape:"pill"}}
                              createOrder={createOrder}
                              onApprove={onApprove} 
                              onError={onError}
                        />
                        {/* asdasd */}
                        </div>
                      </PayPalScriptProvider>
                    </Tab.Panel>
                  </Tab.Panels>
                </Tab.Group>
              </div>
              <div className="top-30-back"> <ButtonPrimary onClick={backtoSecondSteps}>Back </ButtonPrimary></div>
            </div>
          </Transition>
          {/* ------------STEP Confirm and payment END HERE------------ */}  
          </>
      );
  }
  const renderPackageSelections = () =>{
    return(
        <>
          <div className=" w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-4 px-0 sm:p-6 xl:p-5">
            <h2 className="text-3xl lg:text-4xl font-semibold">Your add-ons are as follows! 🎉</h2>
            <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
            {details.ferry_meals_ticket!=0 ?
            <label className="rad-label">
              <div className="w-100 mx-img-2">
                  <img src="https://pictures.tinyaway.com/filters:format(webp)/450x300/lazarus/sweet_and_Sour_fish_with_fried_rice.jpeg"></img>
                  <img src="https://pictures.tinyaway.com/filters:format(webp)/450x300/lazarus/ferry_for_lazarus.jpg"></img>
              </div>
              <div className="w-full-selecte"><p>1 x Ferry (two way) and 1 x set meal ({details.ferry_meals_ticket})</p></div>
              <div className="rad-text">
                <div className="selected">
                  <div className="rad-design">
                    <div><b>SGD${details.ferry_meals_ticket*20}</b></div>
                  </div>
                </div>
              </div>
            </label>
            :
            ""}

            {details.ferry_ticket!=0 ?
            <label className="rad-label">
            <div className="w-100">
              <img src="https://pictures.tinyaway.com/filters:format(webp)/450x300/lazarus/ferry_for_lazarus.jpg"></img>
            </div>
            <div className="w-full-selecte"><p>1 x Ferry (two way) ({details.ferry_ticket})</p></div>
            <div className="rad-text">
              <div className="selected">
                <div className="rad-design">
                  <div><b>SGD${details.ferry_ticket*12}</b></div>
                </div>
              </div>
            </div>
            </label>
            :""
            }
            
            {details.meals!=0 ?
            <label className="rad-label ">
              <div className="w-100">
                  <img src="https://pictures.tinyaway.com/filters:format(webp)/450x300/lazarus/sweet_and_Sour_fish_with_fried_rice.jpeg"></img>
              </div>
              <div className="w-full-selecte"><p>1 x set meal ({details.meals})</p></div>
              <div className="rad-text">
                <div className="selected">
                  <div className="rad-design">
                    <div><b>SGD${details.meals*8}</b></div>
                  </div>
                </div>
              </div>
            </label>
            :""
            }
            {details.pets!=0 ?
            <label className="rad-label ">
            <div className="w-100 font-100-mid">
              <i className="svg-box-dog">
              <svg width="88" height="100" viewBox="0 0 88 114" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M58.1806 43.7256C58.3097 44.1682 58.4388 44.5002 58.531 44.8506C59.1949 47.5986 59.9326 50.3282 60.4675 53.0946C61.8876 60.3058 62.3118 67.5538 60.8917 74.8019C60.0249 79.2835 58.8261 83.7098 57.6642 88.1361C55.9305 94.8124 55.4141 101.507 56.8711 108.294C56.9633 108.755 57.0002 109.124 57.6642 109.179C60.3753 109.475 60.9839 110.157 61.1499 112.942C61.1499 112.997 61.2052 113.034 61.2605 113.126C64.8016 113.126 68.3426 113.126 71.9943 113.126C71.9943 112.038 71.9205 111.005 72.0127 109.972C72.2156 107.446 70.4635 105.989 68.3057 105.823C67.5865 105.768 67.3836 105.436 67.236 104.864C65.9266 99.7182 65.9635 94.5727 67.1623 89.4455C68.1582 85.2406 69.4123 81.0909 70.4267 76.8859C72.4185 68.6235 72.8058 60.3242 70.7586 51.9696C69.2832 45.9387 68.6192 39.8157 69.0803 33.6005C69.2832 30.7787 69.818 28.0491 71.4226 25.6516C72.0865 24.6741 72.9349 23.9733 74.0415 23.4384C76.6419 22.2027 79.2239 20.8933 81.6953 19.3994C82.7834 18.7355 83.6687 18.4404 84.9043 18.7724C85.5683 18.9568 86.4535 18.8461 87.099 18.551C88.1503 18.0715 88.1318 17.1125 87.1175 16.5223C86.5458 16.1904 85.9187 15.9875 85.2732 15.7108C85.3838 15.3235 85.5129 14.9731 85.5867 14.6227C85.9002 13.1288 86.306 11.635 86.4904 10.1226C86.7671 7.89105 86.0293 7.02423 83.8346 6.67382C83.4473 6.61849 83.0416 6.56316 82.6543 6.52627C80.3674 6.28652 78.062 6.0652 75.7751 5.807C74.4472 5.65946 73.3591 5.14306 72.4738 4.03648C70.9984 2.21063 68.9881 1.1225 66.7012 0.624546C61.9798 -0.408257 57.2031 -0.0578418 52.6477 1.19628C46.6169 2.85614 41.9693 6.72914 38.3913 11.8378C38.0594 12.3173 37.8381 12.8706 37.6352 13.4055C37.1741 14.5674 37.3401 15.6371 38.2807 16.5223C41.8217 19.8605 45.7501 22.7191 49.955 25.1905C50.6928 25.6147 51.2276 25.4671 51.7071 24.8401C53.6436 22.3134 54.6211 19.6023 53.4776 16.4301C52.7399 14.4198 52.3711 12.3358 52.6293 10.178C52.869 8.18613 53.7358 6.56316 55.5248 5.12461C55.3219 5.71479 55.2113 6.0652 55.1006 6.41562C54.3629 8.66565 53.994 10.9526 54.5104 13.3133C54.7686 14.512 55.1191 15.6924 55.4695 16.8727C56.3178 19.6207 55.9305 22.1659 54.4551 24.6372C52.6293 27.6987 51.412 28.1598 48.2398 26.5553C46.6353 25.7438 45.0677 24.8216 43.4631 23.9364C43.3709 24.2499 43.2972 24.545 43.2234 24.8401C41.1762 32.7705 38.3176 40.3505 33.8175 47.2482C30.3687 52.5229 26.219 57.2074 22.0878 61.9287C16.7209 68.0702 11.4278 74.2302 6.68799 80.8696C4.4564 83.9864 2.59367 87.3062 1.45021 90.9763C-0.892037 98.4826 -0.560064 105.694 3.94 112.425C4.30886 112.979 4.67772 113.2 5.34166 113.2C7.73924 113.163 10.1368 113.163 12.5344 113.182C18.5099 113.237 24.4485 112.979 30.3502 112.038C34.5737 111.356 38.4282 109.899 41.5451 106.893C44.8832 103.702 46.5247 99.8105 46.1927 95.1444C45.8607 90.5521 42.8176 86.6238 38.4836 85.3328C34.6474 84.1893 30.9773 84.6873 27.6022 86.8082C24.762 88.5787 23.0837 91.1976 22.5858 94.4989C22.4013 95.7346 23.1206 96.6936 24.2088 96.8965C25.3153 97.0994 26.4219 96.417 26.5879 95.2366C27.0674 91.5849 30.2949 89.0029 34.4814 88.8554C37.709 88.7263 40.3647 90.3124 41.5082 93.0972C42.6516 95.919 42.3197 98.6486 40.8442 101.249C38.9446 104.569 35.9569 106.505 32.3421 107.409C26.3297 108.921 20.1882 109.05 14.0283 109.124C13.4565 109.124 13.4012 108.829 13.3274 108.386C12.7373 104.735 12.4606 101.065 12.811 97.376C13.3643 91.7509 15.2455 86.6976 18.8972 82.3266C21.9218 78.7118 25.6473 75.9638 29.7969 73.8244C33.5409 71.9064 37.3954 70.228 41.1578 68.3653C42.4672 67.7198 43.7029 66.8899 44.9017 66.0231C45.4181 65.6542 45.7316 65.0271 46.1742 64.4739C45.5841 64.1788 45.1783 63.9759 44.7726 63.7546C42.3566 62.3345 41.0471 60.232 40.9918 57.4287C40.918 54.2565 42.2459 51.656 44.5328 49.5167C45.0308 49.0556 45.2521 48.5945 45.289 47.9306C45.3259 47.156 45.4365 46.3814 45.5472 45.4777C46.2111 45.9203 46.7829 46.2338 47.2439 46.658C48.7009 47.9859 50.3608 48.5392 52.2973 48.2257C52.7768 48.1519 53.3116 48.0044 53.6805 47.7093C55.1559 46.4183 56.6129 45.0904 58.1806 43.7256ZM50.4346 53.7954C50.4346 54.7729 51.0247 55.5844 51.7624 55.6028C52.537 55.6213 53.1641 54.8098 53.1641 53.777C53.1641 52.8179 52.5555 51.9696 51.8362 51.9511C51.0801 51.9142 50.4346 52.7811 50.4346 53.7954ZM45.5472 53.7954C45.5472 53.0024 45.0492 52.2831 44.4591 52.3569C43.666 52.4491 43.4447 53.0393 43.4078 53.7401C43.3709 54.5516 43.832 55.2155 44.4406 55.234C45.0308 55.2524 45.5287 54.6069 45.5472 53.7954ZM47.5575 56.5434C46.5247 56.5434 45.6763 56.5434 44.6804 56.5434C45.1046 57.4287 45.455 58.1479 45.8792 59.0332C46.4878 58.1479 46.9857 57.3918 47.5575 56.5434Z" fill="white"/>
                <path d="M58.1806 43.7256C56.6129 45.1088 55.1559 46.4183 53.6621 47.6724C53.3116 47.9675 52.7584 48.115 52.2788 48.1888C50.3423 48.5023 48.6825 47.949 47.2255 46.6211C46.7644 46.197 46.1742 45.8834 45.5287 45.4408C45.4365 46.3445 45.3074 47.1191 45.2705 47.8937C45.2521 48.5577 45.0123 49.0187 44.5144 49.4798C42.2275 51.6192 40.918 54.2012 40.9733 57.3918C41.0287 60.1951 42.3381 62.3161 44.7541 63.7177C45.1414 63.939 45.5656 64.1419 46.1558 64.437C45.7132 64.9903 45.3996 65.6173 44.8832 65.9862C43.6844 66.8346 42.4672 67.6645 41.1393 68.3284C37.377 70.1912 33.504 71.8695 29.7785 73.7875C25.6288 75.9269 21.9034 78.6749 18.8787 82.2897C15.2271 86.6607 13.3459 91.7325 12.7926 97.3391C12.4422 101.028 12.7004 104.698 13.309 108.35C13.3828 108.792 13.4381 109.087 14.0098 109.087C20.1513 108.995 26.3112 108.866 32.3236 107.372C35.9384 106.468 38.9262 104.532 40.8258 101.212C42.3012 98.6301 42.6332 95.8821 41.4897 93.0604C40.3647 90.2755 37.7089 88.6894 34.463 88.8185C30.2765 88.966 27.0489 91.548 26.5694 95.1997C26.4219 96.3801 25.3153 97.0625 24.1903 96.8596C23.0837 96.6752 22.3645 95.6977 22.5673 94.462C23.0653 91.1423 24.762 88.5419 27.5838 86.7713C30.9588 84.6504 34.629 84.1524 38.4651 85.2959C42.7992 86.5869 45.8423 90.5152 46.1742 95.1075C46.5062 99.7736 44.8648 103.665 41.5266 106.856C38.3913 109.862 34.5368 111.319 30.3318 112.001C24.4301 112.96 18.473 113.2 12.5159 113.145C10.1184 113.126 7.72079 113.126 5.32322 113.163C4.65927 113.182 4.29041 112.942 3.92156 112.389C-0.578512 105.675 -0.910484 98.4641 1.43176 90.9579C2.57522 87.2877 4.43796 83.968 6.66955 80.8512C11.4094 74.2117 16.7209 68.0334 22.0694 61.9103C26.2006 57.1889 30.3502 52.486 33.7991 47.2298C38.2991 40.3321 41.1578 32.7521 43.2049 24.8216C43.2787 24.5266 43.3709 24.2315 43.4447 23.9179C45.0677 24.8032 46.6169 25.7253 48.2214 26.5368C51.3936 28.1414 52.6108 27.6803 54.4367 24.6188C55.9121 22.1474 56.2994 19.6023 55.451 16.8543C55.0822 15.674 54.7502 14.4936 54.492 13.2948C53.9756 10.9526 54.3444 8.64722 55.0822 6.39718C55.1928 6.04677 55.3035 5.7148 55.5063 5.10618C53.7174 6.54473 52.8506 8.18614 52.6108 10.1595C52.3526 12.3174 52.7399 14.383 53.4592 16.4117C54.6211 19.6023 53.6436 22.3134 51.6887 24.8216C51.2092 25.4487 50.6743 25.5962 49.9366 25.1721C45.7316 22.7007 41.8217 19.8605 38.2622 16.5039C37.3216 15.6186 37.1557 14.5489 37.6167 13.387C37.8196 12.8522 38.0409 12.2805 38.3729 11.8194C41.9508 6.69227 46.5984 2.8377 52.6293 1.17784C57.1847 -0.0762744 61.9614 -0.426689 66.6827 0.606113C68.9697 1.10407 70.9799 2.17376 72.4554 4.01805C73.3406 5.12462 74.4288 5.64102 75.7567 5.78857C78.0436 6.04677 80.3305 6.26808 82.6358 6.50784C83.0416 6.54473 83.4289 6.60006 83.8162 6.65538C86.0293 7.0058 86.7486 7.87262 86.472 10.1042C86.2875 11.6165 85.8818 13.1104 85.5683 14.6043C85.4945 14.9547 85.3654 15.3051 85.2547 15.6924C85.8818 15.969 86.5273 16.1719 87.099 16.5039C88.1134 17.0941 88.1503 18.0531 87.0806 18.5326C86.4351 18.8277 85.5498 18.9384 84.8859 18.7539C83.6502 18.422 82.765 18.717 81.6768 19.381C79.2239 20.8749 76.6419 22.1843 74.023 23.42C72.9164 23.9548 72.0681 24.6557 71.4041 25.6331C69.7811 28.0307 69.2647 30.7418 69.0619 33.582C68.6008 39.7973 69.2832 45.9203 70.7402 51.9511C72.7689 60.3058 72.4 68.5866 70.4082 76.8675C69.3939 81.0725 68.1213 85.2221 67.1438 89.4271C65.945 94.5542 65.9081 99.7183 67.2176 104.845C67.3651 105.436 67.568 105.749 68.2873 105.804C70.4451 105.989 72.1972 107.427 71.9943 109.954C71.9205 110.987 71.9759 112.02 71.9759 113.108C68.3242 113.108 64.7647 113.108 61.2421 113.108C61.1868 113.034 61.1499 112.979 61.1314 112.923C60.9654 110.157 60.3568 109.475 57.6457 109.161C57.0002 109.087 56.9633 108.718 56.8527 108.276C55.3957 101.489 55.9121 94.794 57.6457 88.1177C58.7892 83.6914 59.988 79.2651 60.8732 74.7835C62.2933 67.5354 61.8691 60.2873 60.449 53.0762C59.8958 50.3097 59.158 47.5802 58.5125 44.8322C58.4388 44.5002 58.3097 44.1498 58.1806 43.7256ZM63.7688 9.51403C65.1704 7.68819 66.8487 6.93203 69.0988 8.00172C68.1951 6.93203 67.2176 6.21275 65.8528 6.6185C64.5065 7.02424 63.9532 8.13082 63.7688 9.51403Z" fill="black"/>
                <path d="M50.4345 53.7954C50.4345 52.7811 51.08 51.9143 51.8362 51.9511C52.5555 51.9696 53.1641 52.818 53.1641 53.777C53.1641 54.8098 52.537 55.6213 51.7624 55.6028C51.0247 55.5844 50.4345 54.7914 50.4345 53.7954Z" fill="black"/>
                <path d="M45.5472 53.7954C45.5472 54.6069 45.0492 55.234 44.4406 55.2155C43.8504 55.1971 43.3709 54.5331 43.4078 53.7217C43.4447 53.0393 43.666 52.4307 44.459 52.3384C45.0308 52.3016 45.5472 53.0024 45.5472 53.7954Z" fill="black"/>
                <path d="M47.5575 56.5434C46.9857 57.3918 46.4878 58.1295 45.8791 59.0332C45.455 58.148 45.1045 57.4287 44.6804 56.5434C45.6763 56.5434 46.5246 56.5434 47.5575 56.5434Z" fill="black"/>
                </svg>
                </i>
             </div>
              <div className="w-full-selecte"><p>1 x set Pets ({details.pets})</p></div>
              <div className="rad-text">
                <div className="selected">
                  <div className="rad-design">
                    <div><b>SGD${details.pets*30}</b></div>
                  </div>
                </div>
              </div>
            </label>
            :""
            }
            
            </div>
        </>
    )
  }

  return (
    <div className={`nc-PayPage ${className}`} data-nc-id="PayPage">
      <Helmet title="Tiny Away | Payment Success"></Helmet>
      {isdataLoaded  ?
        <div>
        <main className="container mt-11 mb-4 lg:mb-2 flex flex-col-reverse lg:flex-row">
          {isBookingFound ?
            renderBookingDetails()
            :
            ""
          }
        </main>
        {isBuyAddonButton ?
          <>
          {!isPaymetContrainer ? 
          <main className="container mt-11 mb-4 lg:mb-2 flex flex-col-reverse lg:flex-row">
            {renderContent()}
          </main>
          :""
          }
          {isPaymetContrainer ? 
          <div className="container mt-11  lg:mb-11 flex flex-col-reverse lg:flex-row gap-5">
              {renderPackageSelections()}
              <div className=" w-2/3 flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-5 px-0 sm:p-6 xl:p-5">
              {renderPatmentContainer()}
              </div>
            </div>
          :""}
          </>
         :
         <>
         {!isBuyAddonButton ? 
           <div dangerouslySetInnerHTML={ {__html: bookingResponse?.html_addons} } />
            :
           ""
          }
         </>
        }
        </div>
      :
        <main className="container mt-11 mb-24 lg:mb-32 ">
        {renderskeletonLoader()}
        </main>
      }
      
    </div>
  );
};

export default PayPage;